"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3ZM4 4c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4Zm10 12h1c0-3.86-3.14-7-7-7s-7 3.14-7 7h1c0-3.309 2.691-6 6-6s6 2.691 6 6Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 6.188a5.068 5.068 0 0 1 5.063-5.063 5.068 5.068 0 0 1 5.062 5.063 5.068 5.068 0 0 1-5.063 5.062A5.068 5.068 0 0 1 6.75 6.187Zm-1.125 0a6.195 6.195 0 0 0 6.188 6.187A6.195 6.195 0 0 0 18 6.187 6.195 6.195 0 0 0 11.812 0a6.195 6.195 0 0 0-6.187 6.188ZM21 24h1.125c0-5.686-4.626-10.313-10.313-10.313C6.127 13.688 1.5 18.314 1.5 24h1.125c0-5.066 4.121-9.188 9.188-9.188C16.878 14.813 21 18.934 21 24Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9 8.25a6.758 6.758 0 0 1 6.75-6.75 6.758 6.758 0 0 1 6.75 6.75A6.758 6.758 0 0 1 15.75 15 6.758 6.758 0 0 1 9 8.25Zm-1.5 0c0 4.549 3.701 8.25 8.25 8.25 4.549 0 8.25-3.701 8.25-8.25C24 3.701 20.299 0 15.75 0 11.201 0 7.5 3.701 7.5 8.25ZM28 32h1.5c0-7.582-6.168-13.75-13.75-13.75S2 24.418 2 32h1.5c0-6.755 5.495-12.25 12.25-12.25S28 25.245 28 32Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M13.468 12.188c0-5.687 4.626-10.313 10.312-10.313 5.687 0 10.313 4.626 10.313 10.313 0 5.686-4.626 10.312-10.313 10.312-5.686 0-10.312-4.626-10.312-10.313Zm-1.875 0c0 6.72 5.467 12.187 12.187 12.187s12.188-5.468 12.188-12.188C35.968 5.468 30.5 0 23.78 0c-6.72 0-12.187 5.468-12.187 12.188ZM42.75 47.996h1.875c0-11.27-9.168-20.438-20.438-20.438-11.268 0-20.437 9.169-20.437 20.438h1.875c0-10.236 8.327-18.563 18.563-18.563 10.235 0 18.562 8.327 18.562 18.563Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M17.957 16.25c0-7.582 6.168-13.75 13.75-13.75s13.75 6.168 13.75 13.75S39.289 30 31.707 30s-13.75-6.168-13.75-13.75Zm-2.5 0c0 8.96 7.29 16.25 16.25 16.25s16.25-7.29 16.25-16.25S40.667 0 31.707 0s-16.25 7.29-16.25 16.25ZM57 63.996h2.5c0-15.026-12.224-27.25-27.25-27.25C17.225 36.746 5 48.97 5 63.996h2.5c0-13.647 11.103-24.75 24.75-24.75S57 50.349 57 63.996Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconMyAccount = function IconMyAccount(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'My Account' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "MyAccount"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconMyAccount.sizes = [16, 24, 32, 48, 64];
IconMyAccount.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconMyAccount;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/MyAccount.js
// module id = 2426
// module chunks = 0